export const surveyQuestionTextFields = [
  'title',
  'description',
  'information',
  'otherLabel',
  'noneLabel',
  'startingQuestion',
  'minValueText',
  'maxValueText',
  'feedbackMessage'
] as const;
